// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-field-tooltip__help{width:30rem}.search-field-tooltip__help-icon{cursor:help}", ""]);
// Exports
module.exports = exports;
